export const CommunityTabs = {
  POSTS: 'posts',
  SELECTIONS: 'selections',
  RECS: 'recs',
  DISCUSSIONS: 'discussions',
  DISCUSSIONS_ALL: 'discussions-all',
  GROUP: 'groups',
  COMMON: 'common',
  GROUP_DISCUSSIONS: 'group-discussions',
} as const;

export type CommunityTabType = (typeof CommunityTabs)[keyof typeof CommunityTabs];
